import React from 'react';
import Gallery1 from '../../../assets/images/rrc/gallery/yugto/1.jpg';
import Gallery2 from '../../../assets/images/rrc/gallery/yugto/2.jpg';
import Gallery3 from '../../../assets/images/rrc/gallery/yugto/3.jpg';
import Gallery4 from '../../../assets/images/rrc/gallery/yugto/4.jpg';
import Gallery5 from '../../../assets/images/rrc/gallery/yugto/5.jpg';
import BrandSlider1 from '../../../components/Slider/BrandSlider1'

const BlogDetailsMain = ({ post }) => {
  if (!post) return null;

  // Show your rich YUGTO write-up if that post is clicked
  if (post.title === 'YUGTO') {
    return (
      <>
        <section className="blog-details">
          <div className="container">
            <div className="row">
              <div className="col-xl-12 col-lg-12">
                <div className="blog-details__left">
                  <div className="blog-details__img-1">
                    <img src={Gallery1} alt="YUGTO Event Poster" />
                    <div className="blog-details__date"><p>31 May</p></div>
                  </div>

                  <div className="blog-details__content">
                    <h3 className="blog-details__title-1">
                      YUGTO: Racket Riot Club&apos;s 1st Anniversary Tournament for a Cause
                    </h3>
                    <p className="blog-details__text-1">ᜌᜓᜄ᜔ᜆᜓ — Bagong kabanata. Bagong riot.</p>
                    <p className="blog-details__text-2">
                      🔥 Walang atrasan. Matira, matibay. What started as rallies and smashes became something so much deeper...
                    </p>

                    <h3 className="blog-details__title-2">More Than Just a Tournament</h3>
                    <p className="blog-details__text-3">
                      YUGTO wasn’t just about rallies and smashes — it was about making real human connections...
                    </p>

                    <div className="blog-details__points-box">
                      <ul className="blog-details__points list-unstyled">
                        <li><div className="icon"><span className="icon-double-angle"></span></div><p>Walang atrasan. Matira, matibay.</p></li>
                        <li><div className="icon"><span className="icon-double-angle"></span></div><p>Smash for a cause — play with purpose</p></li>
                      </ul>
                      <ul className="blog-details__points list-unstyled">
                        <li><div className="icon"><span className="icon-double-angle"></span></div><p>Riot community built on connection</p></li>
                        <li><div className="icon"><span className="icon-double-angle"></span></div><p>Giving back through every rally</p></li>
                      </ul>
                    </div>

                    <h3 className="blog-details__title-2 mt-5">🏆 Tournament Winners</h3>
                    <p className="blog-details__text-4">
                      Congratulations to the champions of our first-ever YUGTO Tournament!
                    </p>

                    <div className="blog-details__img-box my-4 text-center">
                      <div className="row g-4">
                        {[Gallery2, Gallery3, Gallery4, Gallery5].map((img, i) => (
                          <div className="col-sm-6 col-md-3" key={i}>
                            <div className="blog-details__gallery-img">
                              <img src={img} alt={`YUGTO Gallery ${i + 1}`} className="img-fluid rounded" />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                      <h3 className="blog-details__title-1">
                     Event Sponsors
                    </h3>
                    <hr></hr>
              <BrandSlider1 />
                    <hr></hr>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </section>
      </>
    );
  }

  // Fallback for non-YUGTO posts (simple poster + meta)
  return (
    <section className="blog-details">
      <div className="container">
        <div className="text-center">
          <img src={post.image} alt={post.title} className="img-fluid rounded mb-3" />
          <h3 className="mb-1">{post.title}</h3>
          <p className="text-muted">By {post.author} • {post.date}</p>
          <p>Highlights and full write-up coming soon.</p>
        </div>
      </div>
    </section>
  );
};

export default BlogDetailsMain;
